/**
 * The scope a transcript's attachments live in, so a message's file chip can
 * fetch its preview (the content route is per scope). Hosts that render agent
 * messages provide it; without it chips show the name only.
 */
import { createContext, useContext, type FC, type ReactNode } from "react";

import type { AgentScope } from "../types";

const AttachmentScopeContext = createContext<AgentScope | null>(null);

export const AttachmentScopeProvider: FC<{
  scope: AgentScope | null | undefined;
  children: ReactNode;
}> = ({ scope, children }) => (
  <AttachmentScopeContext.Provider value={scope ?? null}>
    {children}
  </AttachmentScopeContext.Provider>
);

export const useAttachmentScope = (): AgentScope | null =>
  useContext(AttachmentScopeContext);
